(function () {
    'use strict';

    angular.module('blocks.smart', [
        'blocks.logger',
        'smart-table',
        'daterangepicker'
    ]);
})();
